import React, { useState } from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { AcmeWide, DomeText } from "../components/typography";
import Breakpoints from "../components/styles/Breakpoints";
import DomeHeader from "../components/DomeHeader";
import { Colors } from "../components/styles/Colors";
import { Link } from "gatsby";

const Wrapper = styled.div`
  background-color: ${Colors.cream2};

  padding: 60px 0 40px;
  
  .inner {
    padding: 0px 0px 80px;
    height: auto;

    @media ${Breakpoints.desktop} {
      display: flex;
      height: 60vh;
      max-height: 700px;
      min-height: 500px;
    }

    .left,
    .right {
      width: 100%;

      @media ${Breakpoints.desktop} {
        width: 50%;
      }
    }

    .left {
      position: relative;
      height: 50vh;

      @media ${Breakpoints.desktop} {
        height: 100%;
      }

      & > div {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        opacity: 0;
        transition: opacity .3s;

        .gatsby-image-wrapper {
          height: 550px;
          width: 100%;
        }

        &.active {
          opacity: 1;
        }
      }
    }

    .right {
      position: relative;
      height: 50vh;

      @media ${Breakpoints.desktop} {
        height: auto;
        padding-right: 120px;
      }

      & > div:first-child {
        width: 100%;
        height: 100%;
        position: relative;

        .items {
          & > div {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity .3s;
            pointer-events: none;

            @media ${Breakpoints.desktop} {
              justify-content: flex-start;
            }

            .quote {
              padding: 30px;
              text-align: center;

              @media ${Breakpoints.desktop} {
                text-align: left;
                padding: 100px 80px 100px 100px;
              }

              .quote-text {
                font-family: ${AcmeWide};
                font-size: 20px;
                line-height: 1.2;
                color: ${Colors.grey};
                position: relative;

                @media ${Breakpoints.desktop} {
                  font-size: 30px;
                }

                &:before {
                  content: none;
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  color: ${Colors.sage};
                  font-size: 70px;
                  transform: translate(-110%, -30%);

                  @media ${Breakpoints.desktop} {
                    content: '“';
                  }
                }
              }
            }

            &.active {
              opacity: 1;
              pointer-events: auto;
            }
          }
        }
      }

      .controls {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media ${Breakpoints.desktop} {
          right: 0px;
          top: 0px;
          bottom: auto;
          left: auto;
          height: 100%;
          width: auto;
        }

        ul {
          padding: 0px;
          margin: 0px;
          display: flex;

          @media ${Breakpoints.desktop} {
            display: block;
          }
        }
        
        li {
          list-style: none;
          margin: 0px 10px;

          @media ${Breakpoints.desktop} {
            margin: 10px 0px;
          }

          button {
            appearance: none;
            border: 0;
            outline: 0;
            cursor: pointer;
            background: none;
            margin: 0;
            padding: 0;

            svg {
              width: 20px;

              .inner {
                opacity: 0;
                transition: opacity .3s, fill .3s;
              }
            }

            &:hover {
              svg {
                .inner {
                  fill: ${Colors.greyLight};
                  opacity: 1;
                }
              }
            }
          }

          &.active {
            button svg .inner {
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;

export default function ReviewCarousel({ items }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <Wrapper>
      <div className="inner">
        <div className="left">
          {items.map((item, index) => (
            <div className={index === currentIndex ? ' active' : null}>
              <Image key={index} fluid={item.image.fluid} />
            </div>
          ))}
        </div>

        <div className="right">
          <div>
            <div className="items">
              {items.map((item, index) => (
                <div key={index} className={index === currentIndex ? ' active' : null}>
                  <div className="quote">
                    <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M28 14C28 6.26801 21.732 2.59151e-07 14 1.66948e-07C6.26801 7.47453e-08 9.2203e-08 6.26801 0 14L28 14Z" fill="#FFC000" />
                    </svg>
                    <p className="quote-text">{item.quote}”</p>
                    <DomeText>{item.quoteSource}</DomeText>
                  </div>
                </div>
              ))}
            </div>

            {items.length > 1 &&
              <div className="controls">
                <ul>
                  {items.map((item, index) => (
                    <li className={index === currentIndex ? 'active' : null}>
                      <button onClick={() => setCurrentIndex(index)}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="10" cy="10" r="9.5" stroke="#C4C4C4" />
                          <path className="inner" d="M16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10L16 10Z" fill="#FFC000" />
                        </svg>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
